import React from 'react';

import TotalesForm from './TotalesForm';
import ImpuestosIvaForm from './ImpuestosIvaForm';
import ImpuestosIsrForm from './ImpuestosIsrForm';

const TotalesMain = (props) => {
  const handleOnChange = (data, metadata) => {
    const newMetadata = {
      step: 'totales',
      ...metadata,
    };

    props.onFormDataChange({ Totales: data }, newMetadata);
  };

  const handleOnIvaChange = (event, metadata) => {
    const { Totales = {} } = props.data;

    const iva = {
      ...Totales.iva,
      ...event,
    };

    const { BaseRet, MontoRet, TipoPagoRet } = iva;

    if (!BaseRet && !MontoRet && !TipoPagoRet) {
      const data = {
        ...Totales,
        iva: undefined,
      };
      handleOnChange(data, metadata);
    } else {
      const data = {
        ...Totales,
        iva: {
          ImpuestoRet: '002',
          ...iva,
        },
      };

      handleOnChange(data, metadata);
    }
  };

  const handleOnIsrChange = (event, metadata) => {
    const { Totales = {} } = props.data;

    const isr = {
      ...Totales.isr,
      ...event,
    };

    const { BaseRet, MontoRet, TipoPagoRet } = isr;

    if (!BaseRet && !MontoRet && !TipoPagoRet) {
      const data = {
        ...Totales,
        isr: undefined,
      };
      handleOnChange(data, metadata);
    } else {
      const data = {
        ...Totales,
        isr: {
          ImpuestoRet: '001',
          ...isr,
        },
      };

      handleOnChange(data, metadata);
    }
  };

  const { data = {} } = props;
  const { Totales = {} } = data;
  const { iva, isr } = Totales;

  return (
    <>
      <div className="pb-4">
        <TotalesForm
          original={data}
          data={Totales}
          onFormDataChange={handleOnChange}
        />
      </div>

      {Totales.MontoTotRet > 0 && (
        <>
          <div className="pb-2">
            Total Retenciones <strong>({Totales.MontoTotRet})</strong> es mayor que cero , debe existir al menos IVA
            retenido ó ISR retenido.
          </div>
          <div className="pb-4">
            <div>
              <strong className="text-black text-upper">IVA retenido</strong>
            </div>

            <ImpuestosIvaForm
              original={data}
              data={iva}
              onFormDataChange={handleOnIvaChange}
            />
          </div>

          <div>
            <div>
              <strong className="text-black text-upper">ISR retenido</strong>
            </div>

            <ImpuestosIsrForm
              original={data}
              data={isr}
              onFormDataChange={handleOnIsrChange}
            />
          </div>
        </>
      )}
    </>
  );
};

export default TotalesMain;
